<template>
  <VButton
    :icon-postfix="iconPostfix"
    :theme="theme"
    :type="type"
    :disabled="disabled"
    @click="handleClick"
  >
    <template v-if="hideIcon === false" #icon>
      <VIcon
        theme="outlined"
        material="upload"
      />
    </template>

    <slot/>

  </VButton>
</template>

<script lang="ts">

import FilesService from "@/core/services/Files/FilesService";
import VButton      from "@/lib/components/VButton/VButton.vue";
import VIcon        from "@/lib/components/VIcon/VIcon.vue";
import type EntityPointer from "@/domains/EntityPointer/EntityPointer";

export default defineComponent({
  name: "VFilesUploadButton",

  components: { VButton, VIcon },

  props: {
    /**
     * Сущность к которой привязывается файл
     * @type {EntityPointer}
     */
    entity: {
      type: Object as PropType<EntityPointer>,
      required: true,
    },
    theme: {
      type: String,
      default: "default",
    },
    /**
     * Не загружать файлы на бек, а только отдать выбранные наружу
     * событием selected. Загрузку в этом случае делает родитель.
     */
    disableUpload: {
      type: Boolean,
      default: false
    },
    /** Кнопка выключена. */
    disabled: {
      type: Boolean,
      default: false,
    },
    /** Иконка справа от текста. */
    iconPostfix: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "button",
    },
    hideIcon: {
      type: Boolean,
      default: false,
    }
  },

  emits: ["selected"],

  methods: {
    async handleClick() {
      if (this.disableUpload) {
        /** получаем файлы без загрузки */
        const input = document.createElement("input");
        input.type = "file";
        input.multiple = true;
        input.onchange = () => {
          const files = Array.from(input.files || []);
          this.$emit("selected", files);
        };
        input.click();
        return;
      }

      /** стандартное поведение — загрузка в FilesService */
      await FilesService.showUploadFilesDialog(this.entity);
    }
  }
});
</script>
